import React from 'react';
import * as Yup from 'yup';
import CouponScopePicker from './CouponScopePicker';
import { ruleToApi, scopePagesFromApi } from './scopePage';

export const scopeSchema = Yup.object().shape({
  scopePages: Yup.array().test(
    'scope-picked',
    'Choose at least one checkout or event',
    function (scopePages) {
      if (this.parent.limitScope !== 'some') return true;
      return (scopePages?.length ?? 0) > 0;
    },
  ),
});

/** The form's scope from a saved coupon's `rules`, with its populated `pages` for names. */
export const initialScope = coupon => {
  const scopePages = scopePagesFromApi(coupon);
  return { limitScope: scopePages.length > 0 ? 'some' : 'everywhere', scopePages };
};

/** The coupon's `rules` for create and update; Everywhere sends none. */
export const scopeRules = ({ limitScope, scopePages = [] }) =>
  limitScope === 'some'
    ? scopePages.flatMap(page => page.rules.map(rule => ruleToApi(rule, page)))
    : [];

export const scopeFields = ({ visible, limitScope }) => [
  {
    name: 'limitScope',
    label: 'Where can this coupon be used?',
    type: 'radioCard',
    required: true,
    showRequired: true,
    options: [
      { label: 'Everywhere', labelDescription: 'Every checkout and event', value: 'everywhere' },
      {
        label: 'Only some',
        labelDescription: 'Choose checkouts and events',
        value: 'some',
      },
    ],
    visible,
  },
  {
    type: 'custom',
    name: 'scopePages',
    renderField: () => <CouponScopePicker />,
    visible: visible && limitScope === 'some',
  },
];
